import api from "@/axiosInstance.js";
import type { ApiRequestOptions, User } from "@/types/app";

const apiUrl = `/svnbd/data/deposit/get`;
export const getData = async (fcno: string) => {
  const res = await api.get(`${apiUrl}/fc_no/${fcno}`);
  return res.data.data || [];
};

export const getDataById = async (id: string | number) => {
  const res = await api.get(`${apiUrl}/id/${id}`);
  return res.data.data || [];
};

export const getDataName = async (name: string) => {
  const res = await api.get(`${apiUrl}/name/${name}`);
  return res.data.data || [];
};
export const getMonthlyData = async (date: string) => {
  const res = await api.get(`${apiUrl}/exports/${date}/all`);
  return res.data.data || [];
};
export const getMonthlyDataCount = async (date: string) => {
  const res = await api.get(`${apiUrl}/exports/${date}/count`);
  return res.data.data || [];
};

// Total deposit count
export const totalDeposit = async (
  user: User | null | undefined,
  { signal }: ApiRequestOptions = {},
) => {
  if (!user?.permissions?.includes("see_stats")) return null;
  const res = await api.get(`${apiUrl}/count`, { signal });
  return res.data.data;
};

// Total deposit count
export const totalDepositAmount = async (date: string) => {
  const res = await api.get(`${apiUrl}/exports/${date}/total-amount`);
  return res.data.data;
  // console.log(res)
};
